import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupAll = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/getmyusergroupall' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyUserGroupPage = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/getmyusergrouppage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const changeBusinessUser = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/changebusinessuser/' + params.id + '/' + params.userId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getTeamReport = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/getteamreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getMyBusinessPage = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/getmybusinesspage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const cancel = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/cancel' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmRecept = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/confirmrecept' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchConfirmRecept = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/batchconfirmrecept/' + params.orderList + '/' + params.receptDatetime + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const importOrders = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/importorders' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getReport = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/getreport' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const audit = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/audit' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchAudit = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/batchaudit/' + params.orderList + '/' + params.state + '/' + params.result + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const callBack = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/callback' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchCallBack = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/batchcallback/' + params.orderList + '/' + params.state + '/' + params.result + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const refuseService = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/refuseservice' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const addToRemark = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/addtoremark/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmServiceDatetime = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/confirmservicedatetime' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchConfirmServiceDatetime = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/batchconfirmservicedatetime/' + params.orderList + '/' + params.serviceDatetime + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const callbackClient = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/callbackclient' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const confirmRefuseService = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/confirmrefuseservice' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const tchManualGenerateMonitoringServices = (params, urlParams) => {
  return axios.request({
    url: '/om/monitoringservice/batchmanualgeneratemonitoringservices' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}
